<script>
/* eslint-disable */

import fuzzysort from 'fuzzysort'

export default {
  name: 'ClientListDatatable',
  components: {

  },
  props: {
    clients:{},
    routerName: "",
    actionName: "",
  },
  data() {
    return {
      search: '',
      headers: [
        { text: 'Company', value: 'client_name' },
        { text: 'Contact Name', value: 'contact_name' },
        { text: 'Mobile', value: 'mobile' },
        { text: 'Email', value: 'email' },
        { text: 'Actions', value: 'name', sortable: false },
      ],
      fuzzyTargets: [],
      searchResult: '',
      actualSearch: false,
      loadingData: true,
    }
  },
  watch: {

  },
  mounted() {

  },
  methods: {
    changeRoute(r) {
      this.$router.push(r)
    },
    searchClient() {
      this.actualSearch = true;
    }
  },
  computed: {

    filteredClients: function() {

      let searchKeyWords = [
        'address',
        'client_name',
        'trading_name',
        'phone',
        'mobile',
        'contact_name',
        'email',
        'contact_name',
      ];

      if (this.clients.length) {

        // To make the fuzzy sort more efficient we will reverse map Clients > Services > Sites and flatten into a single object
        this.fuzzyTargets = []

        for (let i = 0; i < this.clients.length; i++) {

          let client = this.clients[i];

          let clientInfoObject = {
            client_name: client.client_name,
            contact_name: client.contact_name,
            phone: client.phone,
            mobile: client.mobile,
            email: client.email,
            client_id: client.id,
            client_idx: i,
            key: client.id + "_" + i
          }

          let serviceInfoObject = {};

          if (client.sites !== undefined) {

            for (let x = 0; x < client.sites.length; x++) {

              let site = client.sites[x]

              if (site !== undefined) {

                serviceInfoObject[`tradding_name_` + x] = site.trading_name;
                serviceInfoObject[`contact_name_` + x] = site.contact_name;
                serviceInfoObject[`address_` + x] = `${site.address}, ${site.suburb}, ${site.postcode}`;
                serviceInfoObject[`phone_` + x] = site.phone;
                serviceInfoObject[`mobile_` + x] = site.mobile;
                serviceInfoObject[`email_` + x] = site.email;

                searchKeyWords.push(`tradding_name_`+x)
                searchKeyWords.push(`contact_name_`+x)
                searchKeyWords.push(`address_`+x)
                searchKeyWords.push(`phone_`+x)
                searchKeyWords.push(`mobile_`+x)
                searchKeyWords.push(`email_`+x)

              }
            }
          }

          // combining two clientInfoObject and serviceInfoObject
          let clientAndServiceInfoObj = Object.assign({}, clientInfoObject, serviceInfoObject);
          this.fuzzyTargets.push(clientAndServiceInfoObj)

        } // End of client for loop

      } // End of if

      // Searching with Fuzzysort
      this.searchResult = fuzzysort.go(this.search.trim(), this.fuzzyTargets, { keys: searchKeyWords } );

      let clientSearchResult = [];
      this.searchResult.map((result) => {
        clientSearchResult.push(result.obj);
      })

      if(this.search.length === 0){
        // adding client_id to client object
        clientSearchResult = this.clients.map(obj=> ({ ...obj, client_id: obj.id }));
      }

      return clientSearchResult;

    }
  },
}
</script>

<template>
  <div>
    <VLayout style="width: 100%">
      <VFlex
        xs0
        sm12
      />
      <VFlex
        xs12
        md5
      >
        <VTextField
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
          @keydown="searchClient"
        />
      </VFlex>
    </VLayout>
      <VDataTable
        class
        :headers="headers"
        :items="filteredClients"
        rows-per-page-text=""
        :rows-per-page-items="[10]"
      >
        <template
          slot="items"
          slot-scope="props"
        >
          <td class="text-xs-left">
            {{ props.item.client_name }}
          </td>
          <td class="text-xs-left">
            {{ props.item.contact_name }}
          </td>
          <td class="text-xs-left">
            <i
              class="fas fa-phone"
              :class="$style.iconSpace"
            /> {{ props.item.mobile }}
          </td>
          <td class="text-xs-left">
            <i
              class="fas fa-envelope"
              :class="$style.iconSpace"
            /> {{ props.item.email }}
          </td>
          <td class="justify-center px-0">
            <VBtn
              slot="activator"
              style="display: block; position:relative; margin: 0 auto"
              color="blue"
              @click.native="changeRoute({name: routerName, params: {id: props.item.client_id, client: props.item}})"
            >
              {{ actionName }}
            </VBtn>
          </td>
        </template>
      </VDataTable>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.routeHeader {
  display: inline-block;
}

.iconSpace{
  margin-right: 4px;
}

.addButton {
  display: inline-block;
  float: right;
}

.error{
    width: 100%;
    padding:25px 25px 0 25px;
    color: red;
    text-align: center;
}

</style>
